var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { Keys, classNames } from '@progress/kendo-react-common';
import * as React from 'react';
/**
 * @hidden
 */

var NewMessage =
/** @class */
function (_super) {
  __extends(NewMessage, _super);

  function NewMessage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      focused: false
    };

    _this.onInputKeyDown = function (event) {
      if (event.keyCode === Keys.enter) {
        _this.sendMessage(event);
      }
    };

    _this.sendMessage = function (event) {
      if (_this.props.onMessageSend) {
        var messageText = _this.inputEl.value;

        if (messageText) {
          var message = {
            author: _this.props.user,
            text: messageText,
            timestamp: new Date()
          };

          _this.props.onMessageSend(message, event);
        }
      }

      _this.inputEl.focus();

      _this.inputEl.value = null;
    };

    return _this;
  }

  NewMessage.prototype.render = function () {
    var _this = this;

    return React.createElement("div", {
      className: "k-message-box"
    }, React.createElement("input", {
      type: "text",
      className: this.getClassNames(),
      placeholder: this.props.placeholder,
      onKeyDown: this.onInputKeyDown,
      onFocus: function onFocus() {
        return _this.setState({
          focused: true
        });
      },
      onBlur: function onBlur() {
        return _this.setState({
          focused: false
        });
      },
      ref: function ref(el) {
        return _this.inputEl = el;
      }
    }), React.createElement("button", {
      className: "k-button k-flat k-button-icon k-button-send",
      onClick: this.sendMessage,
      "aria-label": "Send...",
      dir: this.props.isDirectionRightToLeft ? 'rtl' : undefined
    }, React.createElement("svg", {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      viewBox: "0 0 16 16"
    }, React.createElement("path", {
      d: NewMessage.buttonIconPath
    }))));
  };

  NewMessage.prototype.focusInput = function () {
    this.inputEl.focus();
  };

  NewMessage.prototype.getClassNames = function () {
    return classNames({
      'k-state-focused': this.state.focused
    }, 'k-input');
  }; // tslint:disable-next-line:max-line-length


  NewMessage.buttonIconPath = 'M0,14.3c-0.1,0.6,0.3,0.8,0.8,0.6l14.8-6.5c0.5-0.2,0.5-0.6,0-0.8L0.8,1.1C0.3,0.9-0.1,1.1,0,1.7l0.7,4.2C0.8,6.5,1.4,7,1.9,7.1l8.8,0.8c0.6,0.1,0.6,0.1,0,0.2L1.9,8.9C1.4,9,0.8,9.5,0.7,10.1L0,14.3z';
  return NewMessage;
}(React.Component);

export default NewMessage;